// extracted by mini-css-extract-plugin
export var columnItem = "_dp-3";
export var columnItemDraggable = "_dp-4";
export var dragHandle = "_dp-0";
export var dragHandleHovered = "_dp-1";
export var dropdown = "_dp-5";
export var dropdownContent = "_dp-7";
export var dropdownInner = "_dp-6";
export var filterDropdownHeader = "_dp-8";
export var icon = "_dp-2";
export var sectionDivider = "_dp-9";